import axios from "axios";
import { API_PERU_URL, API_PERU_TOKEN } from "../../config/configEnvs";

const FetchRUC = async ({ ruc, loadingSetter = null }) => {
  if (loadingSetter) loadingSetter(true);

  try {
    if (!ruc || ruc.length !== 11) {
      return false;
    }

    const response = await axios.post(
      `${API_PERU_URL}ruc`,
      { ruc },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_PERU_TOKEN}`,
        },
      }
    );

    const payload = response.data?.data;
    if (!response.data?.success || !payload?.nombre_o_razon_social) {
      return false;
    }

    return {
      brandName: payload.nombre_o_razon_social,
      direccion: payload.direccion_completa || payload.direccion || "",
    };
  } catch (e) {
    return false;
  } finally {
    if (loadingSetter) loadingSetter(false);
  }
};

export default FetchRUC;
